export default function makeCanonicalLink(routePath) {
	const baseFrontendURL = process.env.baseFrontendURL.endsWith('/') ? process.env.baseFrontendURL.slice(0, -1) : process.env.baseFrontendURL;
	const path = (routePath.startsWith('/') ? routePath.slice(1) : routePath);
	return `${baseFrontendURL}/${path}`;
}
